import {useMemo} from "react";

import {useAppSelector} from "../../../../../utils/hooks/store_hooks";
import {selectChartsSelectedRegion} from "../../../components/map/redux/map_city_poc_slice";
import {useEffectiveCitySlug} from "./use_effective_city_slug";

/**
 * Resolves RP `region_id` and `has_charts_access` for `/api/charts/*`.
 *
 * `chartsSelectedRegion` is the only source of truth — set by an explicit pick in
 * `CityMapAutoselect` (or map drill-down). Until a region is selected, callers should
 * treat the state as empty: skip chart fetches and show the empty-card overlay instead
 * of a permission lock (`locked` only when `isRegionIdReady && !hasChartsAccess`).
 */
export const useChartsRegionId = () => {
    const chartsSelectedRegion = useAppSelector(selectChartsSelectedRegion);
    const effectiveCitySlug = useEffectiveCitySlug();

    return useMemo(() => {
        if (chartsSelectedRegion != null) {
            return {
                regionId: chartsSelectedRegion.regionId,
                districtChartsRegionId: chartsSelectedRegion.regionId,
                effectiveCitySlug: chartsSelectedRegion.citySlug ?? effectiveCitySlug,
                hasChartsAccess: chartsSelectedRegion.hasChartsAccess,
                isRegionIdReady: true,
                isRegionIdLoading: false,
                isRegionIdError: false
            };
        }

        return {
            regionId: undefined,
            districtChartsRegionId: undefined,
            effectiveCitySlug,
            hasChartsAccess: false,
            isRegionIdReady: false,
            isRegionIdLoading: false,
            isRegionIdError: false
        };
    }, [chartsSelectedRegion, effectiveCitySlug]);
};
